import {
  AiPriceAlertsMinimalSeverityEnum,
  EntityPrefixDTO,
  InvoicePublishServiceTypeEnum,
  ModuleSettingsOutDTO,
  PriceDisplayTypeEnum,
  ResponseDeadlineModeEnum,
} from '@api/ringil-api.v2';

export interface Form {
  name: string;
  features: string[];
  contentPrefix?: string;
  code?: string;
  crn?: string;
  tin?: string;
  modules: ModuleSettingsOutDTO[];
  dachserLastExportId?: string;
  enabledExpRequirementCodes?: string[];
  prefillRequirementCodes?: string[];
  customerReportingId: string;
  defaultCurrencyIsoCode: string;
  defaultDistributionIntervalInHours: number;
  carrierQuoteValidTillDefaultInHours?: number;
  responseDeadlineMode: ResponseDeadlineModeEnum;
  aiPriceAlertsMinimalSeverity?: AiPriceAlertsMinimalSeverityEnum;
  invoicePublishServiceType?: InvoicePublishServiceTypeEnum;
  prefixManualAppId?: string;
  entityPrefixes: EntityPrefixDTO[];
  autoAcceptModuleForInherited: boolean;
  availableCurrencies: string[];
  priceDisplayType: PriceDisplayTypeEnum;
  cargoTemplateIds: string[];
  externalIdTypes: string[];
  defaultTimezoneId: string;
}

export type DuplicateField = 'crn' | 'tin';

export const normalizeOptionalString = (value?: string | null) => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
};

export interface ConflictErrors {
  crn?: string;
  tin?: string;
}
